export default __webpack_public_path__ + "static/media/edit_appointment.1f804085.svg";